import GearIconPath from "@ingka/ssr-icon/paths/gear";

export default GearIconPath;
